import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BG6MEPCE.js";

// src/sidebar.tsx
import { usePathname } from "next/navigation";
import { createContext, useContext, useEffect, useState } from "react";
import { RemoveScroll } from "react-remove-scroll";
import { jsx } from "react/jsx-runtime";
var SidebarContext = createContext(void 0);
function useSidebarContext() {
  const ctx = useContext(SidebarContext);
  if (!ctx)
    throw new Error("Missing sidebar provider");
  return ctx;
}
function SidebarProvider(props) {
  var _a, _b;
  const [openInner, setOpenInner] = useState(false);
  const [open, setOpen] = [
    (_a = props.open) != null ? _a : openInner,
    (_b = props.onOpenChange) != null ? _b : setOpenInner
  ];
  const pathname = usePathname();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return /* @__PURE__ */ jsx(SidebarContext.Provider, { value: [open, setOpen], children: props.children });
}
function SidebarTrigger(_a) {
  var _b = _a, {
    as
  } = _b, props = __objRest(_b, [
    "as"
  ]);
  const [open, setOpen] = useSidebarContext();
  const As = as != null ? as : "button";
  return /* @__PURE__ */ jsx(
    As,
    __spreadValues({
      "data-open": open,
      onClick: () => {
        setOpen(!open);
      }
    }, props)
  );
}
function SidebarList(_a) {
  var _b = _a, {
    as,
    minWidth
  } = _b, props = __objRest(_b, [
    "as",
    "minWidth"
  ]);
  const [open] = useSidebarContext();
  const [isMobileLayout, setIsMobileLayout] = useState(false);
  useEffect(() => {
    if (minWidth === void 0)
      return;
    const mediaQueryList = window.matchMedia(`(min-width: ${minWidth}px)`);
    const handleChange = () => {
      setIsMobileLayout(!mediaQueryList.matches);
    };
    handleChange();
    mediaQueryList.addEventListener("change", handleChange);
    return () => {
      mediaQueryList.removeEventListener("change", handleChange);
    };
  }, [minWidth]);
  return /* @__PURE__ */ jsx(
    RemoveScroll,
    __spreadProps(__spreadValues({
      as: as != null ? as : "aside",
      "data-open": isMobileLayout ? open : false,
      enabled: isMobileLayout ? open : false
    }, props), {
      children: props.children
    })
  );
}
export {
  SidebarList,
  SidebarProvider,
  SidebarTrigger
};
